import { createBrowserRouter, Navigate } from 'react-router-dom'
import LoginPage from '../features/auth/pages/LoginPage'
import SplashPage from '../features/core/pages/SplashPage'
import DashboardLayout from '../features/overview/layouts/DashboardLayout'
import { MineralsProvider } from '../features/minerals/context/minerals/mineralsProvider'
import MineralsPage from '../features/minerals/pages/MineralsPage'
import MineralCreatePage from '../features/minerals/pages/MineralCreatePage'
import { MineralProvider } from '../features/minerals/context/mineral/mineralProvider'
import LayoutMineral from '../features/minerals/layouts/LayoutMineral'
import MineralEditPage from '../features/minerals/pages/MineralEditPage'
import MineralValueChainCreatePage from '../features/minerals/pages/MineralValueChainCreatePage'
import MineralCountryCreatePage from '../features/minerals/pages/MineralCountryCreatePage'
import MineralCountryEditPage from '../features/minerals/pages/MineralCountryEditPage'
import MineralValueChainEditPage from '../features/minerals/pages/MineralValueChainEditPage'
import OpportunitiesPage from '../features/opportunities/pages/OpportunitiesPage'
import { OpportunitiesProvider } from '../features/opportunities/context/opportunities/OpportunitiesProvider'
import OpportunityCreatePage from '../features/opportunities/pages/OpportunityCreatePage'
import { CountryProvider } from '../features/core/context/country/CountryProvider'
import LayoutCountry from '../features/core/layout/LayoutCountry'
import { SponsorsProvider } from '../features/sponsors/context/sponsors/SponsorsProvider'
import SponsorsPage from '../features/sponsors/pages/SponsorsPage'
import SponsorCreatePage from '../features/sponsors/pages/SponsorCreatePage'
import { SponsorProvider } from '../features/sponsors/context/sponsor/SponsorProvider'
import SponsorEditPage from '../features/sponsors/pages/SponsorEditPage'
import { RequestsProvider } from '../features/sponsors/context/requests/requestsProvider'
import SponsorRequestsPage from '../features/sponsors/pages/SponsorRequestsPage'
import SponsorDetailsPage from '../features/sponsors/pages/SponsorDetailsPage'
import OpportunityEditPage from '../features/opportunities/pages/OpportunityEditPage'
import { OpportunityProvider } from '../features/opportunities/context/opportunity/OpportunityProvider'
import { ReviewersProvider } from '../features/reviewers/context/reviewers/ReviewersProvider'
import ReviewersPage from '../features/reviewers/pages/ReviewersPage'
import ReviewersStatisticsPage from '../features/reviewers/pages/ReviewersStatisticsPage'
import { ReviewerProvider } from '../features/reviewers/context/reviewer/ReviewerProvider'
import ReviewersDetailPage from '../features/reviewers/pages/ReviewersDetailPage'
import CountriesUsersPage from '../pages/form/CountriesUsersPage'
import CountryUserPage from '../pages/form/CountryUserPage'
import UpdateCountryOpportunitySource from '../features/opportunities/pages/UpdateCountryOpportunitySource'
import { SourceProvider } from '../features/opportunities/context/source/SourceProvider'
import CountReviews from '../features/CountReviews'


const router = createBrowserRouter([
  {
    element: <SplashPage />,
    children: [
      {
        path: '/',
        element: <DashboardLayout />,
        children: [
          {
            path: 'minerals',
            element: <MineralsProvider />,
            children: [
              { path: '', element: <MineralsPage /> },
              { path: 'create', element: <MineralCreatePage /> },
              {
                path: ':mineral_id',
                element: <MineralProvider />,
                children: [
                  {
                    path: '',
                    element: <LayoutMineral />,
                    children: [
                      { path: 'edit', element: <MineralEditPage /> },
                      {
                        path: 'value-chain',
                        children: [
                          {
                            path: 'create',
                            element: <MineralValueChainCreatePage />,
                          },
                          {
                            path: 'edit',
                            element: <MineralValueChainEditPage />,
                          },
                        ],
                      },
                      {
                        path: 'countries',
                        children: [
                          {
                            path: ':country_id',
                            element: <CountryProvider />,
                            children: [
                              {
                                path: '',
                                element: <LayoutCountry />,
                                children: [
                                  {
                                    path: 'create',
                                    element: <MineralCountryCreatePage />,
                                  },
                                  {
                                    path: 'edit',
                                    element: <MineralCountryEditPage />,
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'countries',
            children: [
              {
                path: 'opportunities',
                children: [
                  {
                    path: '',
                    element: <OpportunitiesProvider />,
                    children: [{ path: '', element: <OpportunitiesPage /> }],
                  },
                ],
              },
              {
                path: ':country_id',
                element: <CountryProvider />,
                children: [
                  {
                    path: '',
                    element: <LayoutCountry />,
                    children: [
                      {
                        path: 'opportunities',
                        children: [
                          {
                            path: 'source',
                            element: <SourceProvider />,
                            children: [
                              {
                                path: '',
                                element: <UpdateCountryOpportunitySource />,
                              }]
                          },
                          {
                            path: 'create',
                            element: <OpportunityCreatePage />,
                          },
                          {
                            path: ':opportunity_id',
                            element: <OpportunityProvider />,
                            children: [
                              {
                                path: 'edit',
                                element: <OpportunityEditPage />,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },

          {
            path: 'sponsors',
            element: <SponsorsProvider />,
            children: [
              { path: '', element: <SponsorsPage /> },
              { path: 'create', element: <SponsorCreatePage /> },
              {
                path: ':sponsor_id',
                element: <SponsorProvider />,
                children: [
                  { path: '', element: <SponsorDetailsPage /> },
                  { path: 'edit', element: <SponsorEditPage /> },
                ],
              },
              {
                path: 'requests',
                element: <RequestsProvider />,
                children: [{ path: '', element: <SponsorRequestsPage /> }],
              },
            ],
          },
          {
            path: 'reviewers',
            element: <ReviewersProvider />,
            children: [
              { path: '', element: <ReviewersPage /> },
              // {
              //   path: 'statistics',
              //   element: <ReviewersStatisticsPage />,
              // },
              {
                path: ':reviewer_id',
                element: <ReviewerProvider />,
                children: [{ path: '', element: <ReviewersDetailPage /> }],
              },
            ],
          },
          { path: '/', element: <ReviewersStatisticsPage /> },
          { path: '/', element: <CountReviews /> },
          {
            path: 'form',
            children: [
              { path: '', element: <CountriesUsersPage /> },
              { path: ':userId', element: <CountryUserPage /> },
            ],
          },
        ],
      },
      { path: '/session/login', element: <LoginPage /> },
      {
        path: '*',
        element: <Navigate to={'/session/login'} />,
      },
    ],
  },
])

export default router
